import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "no-results d-flex justify-content-start align-items-center" }
const _hoisted_2 = { class: "no-results-text" }
const _hoisted_3 = { class: "no-results-title-text" }
const _hoisted_4 = { class: "no-results-cta" }


export default /*@__PURE__*/_defineComponent({
  __name: 'NoResultsSearch',
  setup(__props) {

const content = window.content

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", null, [
      _createElementVNode("svg", { class: "no-results-icon" }, [
        _createElementVNode("use", { "xlink:href": "#___icon___search-lg-blue" })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(content).flight_no_matches), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(content).flight_no_results), 1)
    ])
  ]))
}
}

})